var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9322 3.09479H27V0H16.9017L13.5458 12.1578H13.454L10.1286 0H0V3.09471H1.0373C1.2771 3.13305 1.49958 3.24147 1.67576 3.40583C1.85193 3.5702 1.97363 3.78288 2.025 4.01618V17.0542C1.97046 17.2792 1.84611 17.4819 1.66916 17.6343C1.49221 17.7868 1.27141 17.8814 1.0373 17.9052H0V21H8.1V17.9052H6.075V4.20002H6.19315L10.8609 21H14.5221L19.2509 4.20002H19.3501V17.9052H17.3251V21H27V17.9052H25.9322C25.7035 17.876 25.4892 17.7788 25.3182 17.6268C25.1471 17.4747 25.0274 17.275 24.975 17.0542V4.01626C25.0246 3.78719 25.1419 3.57759 25.3122 3.41369C25.4824 3.24978 25.6981 3.13886 25.9322 3.09479Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.9762101d1fac5f0f4494695cdb3efb52.svg";
export { ForwardRef as ReactComponent };